import { useTheme } from "../contexts/ThemeContext";
import logoLight from "../Assets/images/VESTN_FullLogo-Sand.png";
import logoDark from "../Assets/images/VESTN_FullLogo-Sand.png";

// Simple className utility function
const cn = (...classes: (string | undefined | null | false)[]): string => {
  return classes.filter(Boolean).join(" ");
};

interface VestnLogoProps {
  className?: string;
  size?: "sm" | "md" | "lg";
}

export const VestnLogo = ({ className, size = "md" }: VestnLogoProps) => {
  const { resolvedTheme } = useTheme();
  const sizes = {
    sm: { height: "56px", width: "auto" },
    md: { height: "3rem", width: "auto" },
    lg: { height: "96px", width: "auto" },
  };

  const sizeConfig = sizes[size];

  return (
    <div className={cn("flex items-center", className)}>
      <img
        src={resolvedTheme === "dark" ? logoDark : logoLight}
        alt="VESTN Logo"
        className="object-contain transition-opacity duration-200 hover:opacity-80"
        style={{
          height: sizeConfig.height,
          width: sizeConfig.width,
        }}
      />
    </div>
  );
};
